import _styled from "@emotion/styled-base";
import React from "react";

import PropTypes from "prop-types";
import style from "./style";
import { constants } from "../../styles";

var TextareaComponent = /*#__PURE__*/_styled("textarea", {
  target: "ep2g6wk0",
  label: "TextareaComponent"
})(style.textarea, ";", style.size, ";", style.validate, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RleHRhcmVhL1RleHRhcmVhLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNNEMiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGV4dGFyZWEvVGV4dGFyZWEuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5pbXBvcnQgc3R5bGUgZnJvbSBcIi4vc3R5bGVcIjtcbmltcG9ydCB7IGNvbnN0YW50cyB9IGZyb20gXCIuLi8uLi9zdHlsZXNcIjtcblxuY29uc3QgVGV4dGFyZWFDb21wb25lbnQgPSBzdHlsZWQoXCJ0ZXh0YXJlYVwiKWBcbiAgJHtzdHlsZS50ZXh0YXJlYX07XG4gICR7c3R5bGUuc2l6ZX07XG4gICR7c3R5bGUudmFsaWRhdGV9O1xuYDtcblxuY29uc3QgVGV4dGFyZWEgPSBwcm9wcyA9PiA8VGV4dGFyZWFDb21wb25lbnQgey4uLnByb3BzfSAvPjtcblxuY29uc3QgeyBTTSwgTUQsIExHIH0gPSBjb25zdGFudHMuc2l6ZXM7XG5jb25zdCB7IFNVQ0NFU1MsIFdBUk5JTkcsIERBTkdFUiB9ID0gY29uc3RhbnRzLmNvbG9ycztcblxuVGV4dGFyZWEucHJvcFR5cGVzID0ge1xuICAvKipcbiAgICogU2l6ZSBvZiB0aGUgZmllbGQuIFVzZSBzbSwgbWQsIG9yIGxnIHZhbHVlcy5cbiAgICovXG4gIHNpemU6IFByb3BUeXBlcy5vbmVPZihbU00sIE1ELCBMR10pLFxuICAvKipcbiAgICogQ29sb3Igb2YgdGhlIGZpZWxkLiBVc2Ugc3VjY2Vzcywgd2FybmluZywgb3IgZGFuZ2VyIHZhbHVlcy5cbiAgICovXG4gIHZhbGlkYXRlOiBQcm9wVHlwZXMub25lT2YoW251bGwsIFNVQ0NFU1MsIFdBUk5JTkcsIERBTkdFUl0pXG59O1xuXG5UZXh0YXJlYS5kZWZhdWx0UHJvcHMgPSB7XG4gIHNpemU6IE1ELFxuICB2YWxpZGF0ZTogbnVsbFxufTtcblxuZXhwb3J0IGRlZmF1bHQgVGV4dGFyZWE7XG4iXX0= */"));

var Textarea = function Textarea(props) {
  return React.createElement(TextareaComponent, props);
};

var _constants$sizes = constants.sizes,
    SM = _constants$sizes.SM,
    MD = _constants$sizes.MD,
    LG = _constants$sizes.LG;
var _constants$colors = constants.colors,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING,
    DANGER = _constants$colors.DANGER;


Textarea.propTypes = {
  /**
   * Size of the field. Use sm, md, or lg values.
   */
  size: PropTypes.oneOf([SM, MD, LG]),
  /**
   * Color of the field. Use success, warning, or danger values.
   */
  validate: PropTypes.oneOf([null, SUCCESS, WARNING, DANGER])
};

Textarea.defaultProps = {
  size: MD,
  validate: null
};

export default Textarea;